import * as React from 'react';
import { useFirstRender } from '../../utils/useFirstRender';
export const useGridRegisterStrategyProcessor = (apiRef, strategyName, group, processor) => {
  const registerPreProcessor = React.useCallback(() => {
    apiRef.current.unstable_registerStrategyProcessor(strategyName, group, processor);
  }, [apiRef, processor, group, strategyName]);
  useFirstRender(() => {
    registerPreProcessor();
  });
  const isFirstRender = React.useRef(true);
  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      registerPreProcessor();
    }
  }, [registerPreProcessor]);
};


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/core/strategyProcessing/useGridRegisterStrategyProcessor.js
// module id = 2360
// module chunks = 25